import { m } from '@aimfora/i18n'

/** The wordmark. Sizes follow the artwork's aspect ratio (470 x 96, or 706 x 200 with tagline). */
export function Logo({ height = 24, tagline = false }: { height?: number; tagline?: boolean }) {
  const ratio = tagline ? 706 / 200 : 470 / 96
  return (
    <img
      src={tagline ? '/brand/aimfora-tagline.png' : '/brand/aimfora.png'}
      alt={m.app_name()}
      width={Math.round(height * ratio)}
      height={height}
      className="block h-auto max-w-full select-none"
      draggable={false}
    />
  )
}
